export default "__VITE_ASSET__B8cvsKi0__"